import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { Gallery } from './components/gallery';

const galleryMount = document.getElementById('cpg-gallery');

if (galleryMount) {
    ReactDOM.render(
        <Gallery
            images={(window as any).galleryBootstrap.images} />
            , galleryMount);
}